module.exports = __webpack_public_path__ + "public/images/curated-tutoring-mobile-frame.8c87cc5d9d547db845db69b1601b3ec4.png";